import React from 'react'
import { Routes, Route } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Header from './components/Header'
import Footer from './components/Footer'

import Home from './pages/Home'
import Tomrer from './pages/Tomrer'
import Tag from './pages/Tag'
import Renovering from './pages/Renovering'
import Projects from './pages/Projects'
import ProjectDetail from './pages/ProjectDetail'
import About from './pages/About'
import Contact from './pages/Contact'
import NotFound from './pages/NotFound'
import Forbidden from './pages/Forbidden'

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-slate-900 text-slate-100 font-sans selection:bg-amber-600 selection:text-white antialiased">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tomrerarbejde" element={<Tomrer />} />
            <Route path="/tag" element={<Tag />} />
            <Route path="/renovering" element={<Renovering />} />
            <Route path="/projekter" element={<Projects />} />
            <Route path="/projekter/:slug" element={<ProjectDetail />} />
            <Route path="/om-agstner-byg" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  )
}
